import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
import {
	CSSProperties,
} from '@mui/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	const getAddIconSpacing = (bottomSpacing: number): CSSProperties => {
		return {
			position: 'absolute',
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				bottom: theme.spacing(bottomSpacing),
				right: theme.spacing(4),
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				bottom: theme.spacing(-3),
				left: theme.spacing(5),
			},
		}
	};

	return createStyles({
		list_headerWrapper: {
			position: 'relative',
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0),
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0, 3),
			},
		},
		list_header: {
			display: 'flex',
			marginBottom: theme.spacing(2),
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(1.5, 3),
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				borderBottom: `2px solid ${theme.palette.info.main}`,
				padding: theme.spacing(2, 3),
				marginBottom: theme.spacing(5),
			},
		},
		list_headerWithAddButton: {
			display: 'flex',
			marginBottom: theme.spacing(2),
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(1.5, 2),
				marginBottom: theme.spacing(0),
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				borderBottom: `2px solid ${theme.palette.info.main}`,
				padding: theme.spacing(2, 3, 2, 14),
				marginBottom: theme.spacing(6),
			},
		},
		list_headerPrimary: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				background: theme.palette.primary.main,
			},
		},
		list_headerSecondary: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				background: theme.palette.secondary.main,
			},
		},
		list_headerWarning: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				background: theme.palette.warning.main,
			},
		},
		list_headerError: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				background: theme.palette.error.main,
			},
		},
		list_headerInfo: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				background: theme.palette.info.main,
			},
		},
		list_headerSuccess: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				background: theme.palette.success.main,
			},
		},
		list_headerLeft: {
			flex: '1 0',
			display: 'flex',
		},
		list_headerRight: {
			display: 'inline-flex',
			justifyContent: 'flex-end',
			flexWrap: 'wrap',
			flex: '0 0 auto',
		},
		list_menuIcon: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				display: 'none',
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				marginRight: theme.spacing(1.5),
				padding: theme.spacing(0),
			},
		},
		list_menuIconPrimary: {
			color: theme.palette.primary.contrastText,
		},
		list_menuIconSecondary: {
			color: theme.palette.secondary.contrastText,
		},
		list_menuIconWarning: {
			color: theme.palette.warning.contrastText,
		},
		list_menuIconError: {
			color: theme.palette.error.contrastText,
		},
		list_menuIconInfo: {
			color: theme.palette.info.contrastText,
		},
		list_menuIconSuccess: {
			color: theme.palette.success.contrastText,
		},
		list_headerTitle: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.h6.fontSize,
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.h4.fontSize,
				color: theme.palette.info.main,
			},
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			height: '100%',
		},
		list_headerTitlePrimary: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				color: theme.palette.primary.contrastText,
			},
		},
		list_headerTitleSecondary: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				color: theme.palette.secondary.contrastText,
			},
		},
		list_headerTitleWarning: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				color: theme.palette.warning.contrastText,
			},
		},
		list_headerTitleError: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				color: theme.palette.error.contrastText,
			},
		},
		list_headerTitleInfo: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				color: theme.palette.info.contrastText,
			},
		},
		list_headerTitleSuccess: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				color: theme.palette.success.contrastText,
			},
		},
		list_sideIconWrapper: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		list_sideIcon: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				marginLeft: theme.spacing(1.5),
				padding: theme.spacing(0),
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				color: theme.palette.info.main,
			},
		},
		list_sideIconPrimary: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				color: theme.palette.primary.contrastText,
			},
		},
		list_sideIconSecondary: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				color: theme.palette.secondary.contrastText,
			},
		},
		list_sideIconWarning: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				color: theme.palette.warning.contrastText,
			},
		},
		list_sideIconError: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				color: theme.palette.error.contrastText,
			},
		},
		list_sideIconInfo: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				color: theme.palette.info.contrastText,
			},
		},
		list_sideIconSuccess: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				color: theme.palette.success.contrastText,
			},
		},
		list_addIcon: getAddIconSpacing(10),
		list_addIconWithNavigation: getAddIconSpacing(17),
		list_addIconOnHeader: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				display: 'none',
			},
		},
		list_addIconOnFooter: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				display: 'none',
			},
		},
		list_bodyWrapper: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0, 3),
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0, 3),
			},
		},
		list_footerWrapperFixed: {
			position: 'relative',
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0, 3, 2, 3),
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0, 3, 3, 3),
			},
			marginTop: theme.spacing(0),
		},
		list_footerWrapper: {
			position: 'relative',
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0, 3, 1, 3),
				marginTop: theme.spacing(2),
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0, 3, 2, 3),
				marginTop: theme.spacing(2),
			},
		},
		list_listItemBottom: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				height: theme.spacing(11),
				width: '100%',
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				display: 'none',
			},
		},
		list_formStatusMessageLabelWrapper: {
			marginTop: theme.spacing(1),
		},
	});
});

export default useStyles;
